enum FeedbackButtonStatus {
    defaultState,
    sendFeedback,
    reportIssue,
    teeTriggeredReportIssue,
}

export default FeedbackButtonStatus;
